import React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"
import Link from "../components/Link"
import Vimeo from "../components/vimeo"

const NotFoundPage = props => (
  <Layout location={props.location}>
    <Seo title="404: Not found" pathname="404" />
    <div className="wide-container">
      <div className="content">
        <h1>404: Not Found</h1>
        <p>You just hit a route that doesn&#39;t exist... the sadness.</p>
        <p>
          If you are new to Emento and want to know more, watch the video below
          or continue to the{" "}
          <Link to="/">front page here by clicking here</Link>
        </p>
        <div className="video-embed">
          <div className="video-player">
            <Vimeo
              videoSrcURL="https://player.vimeo.com/video/276973109?color=d60a52&title=0&byline=0&portrait=0"
              videoTitle="Emento - en digital forløbsguide"
              iframeStyle="video-iframe"
            />
          </div>
        </div>
      </div>
    </div>
  </Layout>
)

export default NotFoundPage
